import { useEffect, useRef } from 'react';

import { useModal } from '../../hooks';
import type { EnrollmentType } from './useCourse';

export const useCourseFinish = (
  enrollment: EnrollmentType,
  checkInitial: boolean = false
) => {
  const firstTimeRef = useRef(true);
  const finished = enrollment.progressPercent === 100;
  const { isOpened, onOpen, onClose } = useModal();

  useEffect(
    () => {
      const firstTime = firstTimeRef.current;
      firstTime && (firstTimeRef.current = false);

      if (!checkInitial && firstTime) return;

      finished && onOpen();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [finished]
  );

  return { isOpened, onClose };
};
